import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import * as yup from "yup";

const initialValues = {
  time: "",
};
const onFormSubmit = async (values) => {
 
};
const validateTimeForm = yup.object().shape({
  time: yup.number().required(" Grace time is required"),
});

export default function DialogChange({
  open,
  handleClose,
  onChangeConvenience,
  convenience,
  updateonConvenience,
}) {

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => onFormSubmit(values)}
        validationSchema={validateTimeForm}
      >
        {({ values }) => (
          <>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogTitle
                id="responsive-dialog-title"
                sx={{
                  height: "19px",
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "14px",
                  lineHeight: "15px",
                  display: "flex",
                  alignItems: "center",
                  color: "#111111",
                  marginTop: "1.2rem",
                }}
              >
                {"Update Convenience"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <input
                    variant="contained"
                    placeholder=" Convenience"
                    onChange={(e) =>
                      onChangeConvenience("convenience", e.target.value)
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 3);
                    }}
                    defaultValue={convenience}
                    style={{
                      padding: "10px 15px",
                      width: "300px",
                      height: "25px",
                      background: "#FFFFFF",
                      border: "1px solid #EBEBEB",
                      borderRadius: "6px",
                    }}
                  ></input>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  sx={{
                    background: "#04AAD",
                    marginRight: "1rem",
                    width: "100.17px",
                    height: "40px",
                    marginBottom: "1.2rem",
                    cursor: "pointer",
                  }}
                  disabled={!convenience}
                  onClick={() => updateonConvenience()}
                >
                  Update
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Formik>
    </>
  );
}
